import { createClient as createSupabaseClient } from '@supabase/supabase-js'
import { validateEnv, isProduction } from '@/lib/env'

// Validate environment variables before initializing
validateEnv()

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!
const supabaseKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!

export const createClient = () => {
  return createSupabaseClient(supabaseUrl, supabaseKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      storageKey: 'supabase.auth.token',
      detectSessionInUrl: true,
      flowType: 'pkce',
      // Use the built-in localStorage implementation
      storage: localStorage
    }
  })
}

export default createClient